export default __webpack_public_path__ + "static/media/confirm.841f56b5.svg";